// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"e776e187","89":"dc9e1da6","134":"b10f23b7","158":"8bf3a6df","483":"330c1a4f","826":"2210aa66","926":"9e5fcab5"}[chunkId] + ".js";
};